import { createContext, useContext, useState } from "react";

interface LiquidityContextType {
  initialLiquidity: string;
  setInitialLiquidity: (value: string) => void;
}

const LiquidityContext = createContext<LiquidityContextType | undefined>(undefined);

export function LiquidityProvider({ children }: { children: React.ReactNode }) {
  const [initialLiquidity, setInitialLiquidity] = useState("0");

  return (
    <LiquidityContext.Provider value={{ initialLiquidity, setInitialLiquidity }}>
      {children}
    </LiquidityContext.Provider>
  );
}

export function useLiquidity() {
  const context = useContext(LiquidityContext);
  if (context === undefined) {
    throw new Error("useLiquidity must be used within a LiquidityProvider");
  }
  return context;
}